import React from "react";
//import PropTypes from "prop-types";
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { getTranslate } from "react-localize-redux";
import { postCustomerShipment, getCustomerShipments, deleteCustomerShipment, putCustomerShipment } from '../../actions/shipment'

// material-ui components
import withStyles from "material-ui/styles/withStyles";

import SweetAlert from "react-bootstrap-sweetalert";


// core components
import IconCard from "components/Cards/IconCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import Table from "components/Table/Table.jsx";
import Button from "components/CustomButtons/Button.jsx";
import RequirementsCard from "components/Cards/RequirementsCard.jsx";
import SimpleForm from "components/SimpleForm/SimpleForm.jsx";

import Wizard from "components/Wizard/Wizard.jsx";

import Step1 from "./AddShipmentWizardSteps/Step1.jsx";
import Step2 from "./AddShipmentWizardSteps/Step2.jsx";
import Step3 from "./AddShipmentWizardSteps/Step3.jsx";
import Step4 from "./AddShipmentWizardSteps/Step4.jsx";

import { shipmentFields } from "variables/variables.jsx";

// material-ui icons
import Assignment from "@material-ui/icons/Assignment";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";

import locationsPageStyle from "assets/jss/material-dashboard-pro-react/views/locationsPageStyle.jsx";


class CustomerShipments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shipments: [],
      alert: null,
      add: {},
      edit: {},
      wizardId: Date.now(),
    };
    this.handleCustomerShipmentAddChange = this.handleCustomerShipmentAddChange.bind(this);
    this.handleCustomerShipmentAddSubmit = this.handleCustomerShipmentAddSubmit.bind(this);
    this.handleCustomerShipmentEditSubmit = this.handleCustomerShipmentEditSubmit.bind(this);
    this.handleCustomerShipmentEditChange = this.handleCustomerShipmentEditChange.bind(this);
    this.handleCustomerShipmentEditCancel = this.handleCustomerShipmentEditCancel.bind(this);
  }

  handleCustomerShipmentEditSubmit(){
    this.props.dispatchPutCustomerShipment(this.props.auth.user, this.state.edit)
    .then( res => {
      return this.props.dispatchGetCustomerShipments(this.props.auth.user);
    })
    .then( shipments => {
      this.setState({edit:{}});
      this.setState({shipments});
      this.setState({
        alert: (
          <SweetAlert
            success
            style={{ display: "block", marginTop: "-100px" }}
            title="Good job!"
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
          >
            You clicked the button!
          </SweetAlert>
        )
      });
    });     

  }  

  handleCustomerShipmentEditChange(e, stateName, type, stateNameEqualTo){
    let value = e.target.value;
    if(e.target.type==="checkbox"){
      value = e.target.checked;
    }
    this.setState({edit:{ ...this.state.edit, [e.target.name]: value }});
    
  }

  handleCustomerShipmentEditCancel(){
      this.setState({edit:{}});    
  }



  handleCustomerShipmentAddSubmit(){
    this.props.dispatchPostCustomerShipment(this.props.auth.user, this.state.add)
    .then( res => {
      return this.props.dispatchGetCustomerShipments(this.props.auth.user);
    })
    .then( shipments => {
      this.setState({wizardId: Date.now()});
      this.setState({shipments});
      this.setState({
        alert: (
          <SweetAlert
            success
            style={{ display: "block", marginTop: "-100px" }}
            title="Good job!"
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
          >
            You clicked the button!
          </SweetAlert>
        )
      });
    });    

  }


  handleCustomerShipmentAddChange(state){

    //if(typeof available !== "undefined") this.setState({add:{available}});

    console.log(state);

    this.setState({add:{...this.state.add, ...state}});
    
  }

  handleConfirmDelete(id){
    this.props.dispatchDeleteCustomerShipment(this.props.auth.user, {id} )
    .then( res => {
      return this.props.dispatchGetCustomerShipments(this.props.auth.user);
    })
    .then( shipments => {
      this.setState({shipments});
      this.hideAlert();
    });
  }

  handleTableAction(action, id){
    if(action==="delete"){
      this.setState({
        alert: (
          <SweetAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="Are you sure?"
            onConfirm={() => this.handleConfirmDelete(id)}
            onCancel={() => this.hideAlert()}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
            cancelBtnCssClass={
              this.props.classes.button + " " + this.props.classes.danger
            }
            confirmBtnText="Yes, delete it!"
            cancelBtnText="Cancel"
            showCancel
          >
            You will not be able to recover this imaginary file!
          </SweetAlert>
        )
      });  
    }  
    if(action==="edit"){
      var item = this.state.shipments.find(function(i) {
        return i.id === id;
      });
      item.available = (item.available===1)?true:false;
      this.setState({editId: Date.now()});

      this.setState({edit:item});
    }
  }
  hideAlert() {
    this.setState({
      alert: null
    });
  }

  componentDidMount() {
    this.props.dispatchGetCustomerShipments(this.props.auth.user)
    .then( shipments => {
      this.setState({shipments});
    });   
  }

  render() {
    const {  translate, classes } = this.props;

    var shipmentTableData = [];
    if(this.state.shipments.length>0){
      this.state.shipments.map((prop,key)=>{
        
        let fillButtons = [
          { color: "success", icon: Edit, action: "edit" },
          { color: "danger", icon: Close, action: "delete" }
        ].map((button, buttonKey) => {
          return (
            <Button color={button.color} customClass={classes.actionButton} onClick={() => this.handleTableAction(button.action, prop.id)} key={buttonKey}>
              <button.icon className={classes.icon} />
            </Button>
          );
        });
        shipmentTableData.push([prop.id, prop.shipmentTrackingCode, prop.location, prop.receiver, fillButtons]);
        return false;
      });
    }

    return (
      <div>
        <GridContainer>
          {this.state.alert}  
          <SimpleForm 
            fields={[...shipmentFields.step1]}
            onChange={this.handleCustomerShipmentEditChange} 
            editId={this.state.editId} 
            state={this.state.edit} 
            open={this.state.edit.id?true:false}
            classes={classes}
            onSubmit={this.handleCustomerShipmentEditSubmit}
            onCancel={this.handleCustomerShipmentEditCancel}
          />
          <ItemGrid xs={12} sm={12} md={6}>
            <RequirementsCard content={translate("requirements.customer_shipments.content")} />
          </ItemGrid>
          <ItemGrid xs={12} sm={12} md={6}>
            <Wizard
              key={this.state.wizardId}
              validate
              steps={[
                { stepName: "About", stepComponent: Step1, stepId: "about" },
                { stepName: "Address", stepComponent: Step2, stepId: "address" },
                { stepName: "Payment", stepComponent: Step3, stepId: "payment" },
                { stepName: "Review", stepComponent: Step4, stepId: "review" },
              ]}
              title="Add a Shipment"
              subtitle="This information will let us know more about you."
              finishButtonClick={this.handleCustomerShipmentAddSubmit}
              sendState={this.handleCustomerShipmentAddChange}
              fullState={this.state.add}
            />
          </ItemGrid>                    
          <ItemGrid xs={12} sm={12} md={6}>
            <IconCard
              icon={Assignment}
              iconColor="rose"
              title="My Shipments"
              content={
                <Table
                  tableHead={[
                    "Id",
                    "Tracking Code",
                    "Location",
                    "Receiver",
                    "Actions"
                  ]}
                  tableData={shipmentTableData}
                />
              }
            />
          </ItemGrid>    
        </GridContainer>
      </div>
    );
  }
}

const mapDispatchToProps = {
  dispatchPostCustomerShipment: (user, data) => postCustomerShipment(user, data),
  dispatchPutCustomerShipment: (user, data) => putCustomerShipment(user, data),
  dispatchGetCustomerShipments: (user) => getCustomerShipments(user),
  dispatchDeleteCustomerShipment: (user, data) => deleteCustomerShipment(user, data),
}

const mapStateToProps = (state, props) => {
  return {
    translate: getTranslate(state.localize),
    auth: state.auth,
    userDetails: state.user.userDetails,
    userRoles: state.user.roles,
  }
}


export default compose(
  withStyles(locationsPageStyle),
  connect(mapStateToProps, mapDispatchToProps)
)(CustomerShipments);




// WEBPACK FOOTER //
// ./src/views/Customer/CustomerShipments.jsx